module.exports = __webpack_public_path__ + "img/logo.ef944415.png";